<template>
    <SidebarItem icon="users" link="/admin/users" :label="$t('admin.sidebar.users')" />
    <SidebarItem icon="orders" link="/admin/orders" :label="$t('admin.sidebar.orders')" />

    <SidebarItem icon="reports" link="/admin/reports" :label="$t('admin.sidebar.reports')" />
    <SidebarItem icon="comments" link="/admin/comments" :label="$t('admin.sidebar.comments')" />
    <SidebarItem icon="black-list" link="/admin/black-list" :label="$t('admin.sidebar.black-list')" />
    <SidebarItem icon="medical_cards" link="/admin/medical_cards" :label="$t('admin.sidebar.medical_cards')" />
    <SidebarItem icon="services" link="/admin/services" :label="$t('admin.sidebar.services')" />
    <SidebarItem icon="professions" link="/admin/professions" :label="$t('admin.sidebar.professions')" />
    <SidebarItem icon="symptoms" link="/admin/symptoms" :label="$t('admin.sidebar.symptoms')" />
    <SidebarItem icon="rate" link="/admin/rate" :label="$t('admin.sidebar.rate')" />
    <SidebarItem icon="list" link="/admin/reasons" :label="$t('admin.sidebar.reasons')" />
    <SidebarItem icon="deletion-reasons" link="/admin/deletion-reasons" :label="$t('admin.sidebar.deletion_reasons')" />

    <SidebarItem icon="map" link="/admin/map" :label="$t('admin.sidebar.map')" />
    <SidebarItem icon="conversations" link="/admin/conversations" :label="$t('admin.sidebar.conversations')" />
    <SidebarItem icon="one-id" link="/admin/one-id-statistics" :label="$t('admin.sidebar.One_ID_statistics')" />
    <SidebarItem icon="users-by-region" link="/admin/users-by-region" :label="$t('admin.sidebar.users-by-region')" />
    <SidebarItem icon="sms-gateway" link="https://getsms.uz/site/login" label="СМС ШЛЮЗ" external />
    <!-- <SidebarItem  icon="ip_telephony" link="/admin/ip-telephony" :label="$t('admin.sidebar.ip_telephony')" /> -->
    <SidebarItem icon="category" link="/admin/treatment-category" :label="$t('table.treatment_category')" />
    <SidebarItem icon="self_employed_status" link="/admin/self-employed-status" :label="$t('admin.sidebar.self_employed_status')" />
    <Promoter />
    <SidebarItem icon="promo_codes" link="/admin/promo-codes" :label="$t('admin.sidebar.promo_codes')" />
    <SidebarItem icon="discount" link="/admin/discounts" :label="$t('table.discount')" />

    <SidebarItem icon="balance" link="/admin/balance" :label="$t('admin.sidebar.balance')" />
    <SidebarItem icon="insurance" link="/admin/insurance" :label="$t('admin.sidebar.insurance')" />
    <SidebarItem icon="users" link="/admin/work-places" :label="$t('admin.sidebar.work_places')" />
    <SidebarItem icon="ai-call-center" link="/admin/ai-call-center" :label="`AI ${$t('role.call_center')}`" />
    <SidebarItem icon="dieta" link="/admin/keto-dieta" :label="$t('admin.sidebar.keto-dieta')" />
    <SidebarItem icon="book" link="/admin/women-notebook" :label="$t('admin.sidebar.women-notebook')" />
    <SidebarItem icon="packages" link="/admin/packages" :label="$t('admin.sidebar.packages')" />

    <li class="role-name">{{ $t('role.call_center') }}</li>
    <CallCenter />

    <!-- <li class="role-name" >{{ $t('role.gp') }}</li> -->
    <!-- gp -->
    <!-- <GP /> -->

    <li class="role-name">{{ $t('role.content_manager') }}</li>
    <!-- content manager -->
    <ContentManager />
</template>

<script setup>
    import SidebarItem from '@/components/sidebar/SidebarItem.vue';
    import Promoter from '@/components/layout/sidebar-menu/promoter.vue';
    import CallCenter from '@/components/layout/sidebar-menu/call-center.vue';
    import ContentManager from '@/components/layout/sidebar-menu/content-manager.vue';

    // import GP from '@/components/layout/sidebar-menu/gp.vue';
    import { onMounted } from 'vue';
    import { useChatSocket, useFeedbackSocket, useGPSocket } from '@/services/socket';
    import { useStore } from 'vuex';
    const store = useStore();
    onMounted(() => {
        store.dispatch('chat/getCounts');
        store.dispatch('feedback/getCounts');
        store.dispatch('feedback/getTechnicalSupportCounts');

        useGPSocket((res) => {
            store.commit('chat/setGpCount');
        });

        useChatSocket(() => {
            store.dispatch('chat/getCounts');
        });

        useFeedbackSocket(() => {
            store.dispatch('feedback/getCounts');
        });
    });
</script>
